//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey } from '@/tools'
import { BlankTitle } from './setting'
export default {
  props: {
    question: {
      type: Object,
      default: () => {
        return {
          v_ownId: setOwnKey(),
          v_active: false,
          v_label: '填空题',
          type: 'blank',
          displayIndex: true,
          title: '请填写本项内容',
          required: true,
          size: 'small',
          rule: 'ignore',
          minLength: null,
          maxLength: null,
          uploadArrow: true,
          uploadArrowRequired: false,
          logic: {
            blocks: {
              typeBlock: 'all',
              list: [],
            },
          },
        }
      },
    },
  },
  components: {
    BlankTitle,
  },
  data() {
    return {
      editorOption: {
        modules: { toolbar: [] },
        placeholder:'请输入'
      },
      curItem: null,
      type: null,
      curQuestion: {},
    }
  },
  computed: {
    editor() {
      return this.$refs['blank-title'].quill
    },
  },
  mounted() {
    let editor = this.editor
    if (editor) {
      this.$nextTick(() => {
        let len = editor.getLength()
        editor.setSelection(len)
      })
    }
  },
  // mounted() {
  //   let radioTitle = this.$refs['blank-title']
  //   if (radioTitle) {
  //     radioTitle.$refs['$textarea'].focus()
  //   }
  // },
  watch: {
    question: {
      handler(newV) {
        this.curQuestion = { ...newV }
      },
      immediate: true,
    },
  },
  methods: {
    headerHandler() {
      this.curItem = null
      this.type = 'title'
    },
    onEditorChange(event) {
      event.quill.deleteText(500, 4)
    },
    blurInput() {
      if (!this.curQuestion.title) {
        this.curQuestion.title = this.question.title
      } else {
        this.question.title = this.curQuestion.title
      }
    },
    getValue(){
      return this.curQuestion
    }
  },
}
